import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import NavigationBar from '../../../navigation/NavigationBar';
import { getVocaboMeasureTitleByKey } from '../../../../constants/shared/MeasuresConstants';
import ProbeDetailsBody from './VocSubmeasuresProbeDetailsBody';
import './VocaboProbeDetails.scss';

const VocaboProbeDetails = ({
    tabs,
    content,
    subResult,
    LinkWrapper,
    fetchFormData,
    isFormFetching,
    selectedMeasure,
}) => (
    <>
        <NavigationBar
            tabs={tabs}
            selectedTabId={selectedMeasure}
            ulTagClassName="nav nav-horizontal"
            LinkWrapper={LinkWrapper}
            navTabsDataTestId="vocabo-nav-tabs"
        />
        <div className="vocabulary-container">
            <div className="measure-title-container space-between">
                <b>{getVocaboMeasureTitleByKey(selectedMeasure)}</b>
                <span className="total">
                    Total words correct: <b>{get(subResult, 'score')}</b>
                </span>
            </div>
            <ProbeDetailsBody
                content={content}
                result={subResult}
                fetchFormData={fetchFormData}
                isFormFetching={isFormFetching}
            />
        </div>
    </>
);

VocaboProbeDetails.defaultProps = {
    tabs: [],
    content: {},
    selectedMeasure: '',
    isFormFetching: false,
    LinkWrapper: () => {},
    fetchFormData: () => {},
};

VocaboProbeDetails.propTypes = {
    tabs: PropTypes.array,
    content: PropTypes.object,
    LinkWrapper: PropTypes.func,
    isFormFetching: PropTypes.bool,
    selectedMeasure: PropTypes.string,
    fetchFormData: PropTypes.func,
    subResult: PropTypes.object.isRequired,
};

export default VocaboProbeDetails;
